import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { configured } from './firebase';
import { registerServiceWorker } from './lib/push';
import { AppProvider } from './state';
import './styles.css';

// The app's home is duoplate.novusai.company; the Firebase default addresses forward there.
const HOME = 'duoplate.novusai.company';
if (import.meta.env.PROD && /^duoplate-app\.(web\.app|firebaseapp\.com)$/.test(location.hostname)) {
  location.replace(`https://${HOME}${location.pathname}${location.search}${location.hash}`);
} else if (configured && import.meta.env.PROD) void registerServiceWorker();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppProvider>
      <App />
    </AppProvider>
  </StrictMode>,
);
